import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialAlertService = {
    options: async () => axios.get(`${API_URL}/material-alerts/options/all`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    list: async () => axios.post(`${API_URL}/material-alerts/list`).then(({data}) => data.data).catch((err) => { throw err }),
    validate: async (formData) => axios.post(`${API_URL}/material-alerts/validate`, formData).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/material-alerts/${id}`).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(`${API_URL}/material-alerts/${id}`).then(({data}) => data).catch((err) => {throw err}),
    save: async (formData, id) => {
        if (id) {
            formData.append('_method', 'PUT');
            return axios.post(`${API_URL}/material-alerts/${id}`, formData).then(({data}) => data).catch((err) => { throw err })
        }

        return axios.post(`${API_URL}/material-alerts`, formData).then(({data}) => data).catch((err) => { throw err })
    },
}

export default MaterialAlertService;